import React from 'react';

import { FormControlLabel, Switch } from '@material-ui/core';

export const EntireDaySwitch = React.memo((props: { entireDay: boolean; onChange: any }) => (
  <FormControlLabel
    control={<Switch checked={props.entireDay} onChange={props.onChange} />}
    label="Entire day"
  />
));